// src/lib/supabase/enrichment-guard.ts
//
// Module-level dedup guard for the fire-and-forget LinkedIn enrichment call, so
// it runs at most once per signed-in session. MUST be reset on sign-out — else
// the flag stays true and the NEXT user on the same device never gets enriched.

let enrichmentTriggered = false;

/** Returns true exactly once until reset; subsequent calls return false. */
export function shouldTriggerEnrichment(): boolean {
  if (enrichmentTriggered) return false;
  enrichmentTriggered = true;
  return true;
}

/** Re-arm the guard. Call on sign-out so the next user on the device enriches. */
export function resetEnrichmentGuard(): void {
  enrichmentTriggered = false;
}
